import React, { useState } from "react";
import { Box, Typography, Modal } from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

const JobApplicationModal = ({ open, handleClose, selectedJob }) => {
  console.log("---->", selectedJob);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    coverLetter: "",
    cv: "",
  });

  const [cvUploadLoading, setCvUploadLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: name === "cv" ? files[0] : value,
    }));
  };

  const handleCVUpload = async (e) => {
    setCvUploadLoading(true);
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "techmentee"); // Replace with your Cloudinary upload preset
    try {
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/denarffyt/image/upload",
        formData
      );
      const cvUrl = response.data.secure_url;
      setFormValues((prevState) => ({
        ...prevState,
        cv: cvUrl,
      }));
      setCvUploadLoading(false);
    } catch (error) {
      toast.error("CV upload failed!");
      setCvUploadLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form values
    const { name, email, phone, experience, coverLetter, cv } = formValues;
    if (!name || !email || !phone || !experience || !coverLetter || !cv) {
      toast.error("All fields are required!");
      return;
    }

    setButtonLoading(true);

    let data = {
      jobId: selectedJob,
      name: formValues?.name,
      email: formValues?.email,
      phone: formValues?.phone,
      experience: formValues?.experience,
      coverLetter: formValues?.coverLetter,
      cvUrl: formValues?.cv,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/applied-jobs/create-applied-job`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    console.log(data);

    try {
      const response = await axios.request(config);
      setFormValues({
        name: "",
        email: "",
        phone: "",
        experience: "",
        coverLetter: "",
        cv: "",
      });
      toast.success(response.data.message);
      setButtonLoading(false);
      handleClose();
    } catch (error) {
      setButtonLoading(false);
      toast.error(error.response.data.message);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6">Apply for Job</Typography>
        <Box component="form" sx={{ mt: 2 }}>
          <div className="border h-[70vh] overflow-y-scroll">
            {cvUploadLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-[#353c3b2f] bg-opacity-50 backdrop-blur-sm">
                <div className="relative">
                  <div className="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-purple-500"></div>
                  <img
                    src="https://www.svgrepo.com/show/509001/avatar-thinking-9.svg"
                    className="rounded-full h-28 w-28 ml-4"
                    alt="Loading"
                  />
                </div>
              </div>
            )}

            <div className="mb-2">
              <label htmlFor="name">Name:</label>
              <br />
              <input
                onChange={handleInputChange}
                value={formValues.name}
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                className="border border-gray-400 rounded outline-none"
              />
            </div>
            <div className="mb-2">
              <label htmlFor="email">Email:</label>
              <br />
              <input
                onChange={handleInputChange}
                value={formValues.email}
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                className="border border-gray-400 rounded outline-none"
              />
            </div>
            <div className="mb-2">
              <label htmlFor="phone">Phone:</label>
              <br />
              <input
                onChange={handleInputChange}
                value={formValues.phone}
                type="tel"
                id="phone"
                name="phone"
                placeholder="Enter your phone number"
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                className="border border-gray-400 rounded outline-none"
              />
            </div>
            <div className="mb-2">
              <label htmlFor="experience">Experience (years):</label>
              <br />
              <input
                onChange={handleInputChange}
                value={formValues.experience}
                type="number"
                id="experience"
                name="experience"
                placeholder="Enter your experience in years"
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                className="border border-gray-400 rounded outline-none"
              />
            </div>
            <div className="mb-2">
              <label htmlFor="cover-letter">Cover Letter:</label>
              <br />
              <textarea
                onChange={handleInputChange}
                value={formValues.coverLetter}
                id="cover-letter"
                name="coverLetter"
                rows="4"
                placeholder="Enter your cover letter"
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                className="border border-gray-400 rounded outline-none"
              ></textarea>
            </div>
            <div className="mb-2">
              <label htmlFor="cv">Upload CV (image format)</label>
              <br />
              <input
                accept="application/pdf,image/*"
                onChange={handleCVUpload}
                type="file"
                id="cv"
                name="cv"
                style={{ width: "100%", padding: "8px", marginTop: "4px" }}
                className="border border-gray-400 rounded outline-none"
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={buttonLoading}
              className="w-[200px] py-2 mt-4 text-white hover:bg-black cursor-pointer rounded-md flex items-center justify-center gap-2"
              style={{ backgroundColor: "#7A96BD" }}
            >
              {buttonLoading ? (
                <>
                  <div className="rounded-md h-5 w-5 border-2 border-white animate-spin"></div>
                  Loading..
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};

export default JobApplicationModal;
